import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import { Button, rem, Spacer } from 'design-system';
import Text from 'design-system/Text';
import { UpgradeWebModal } from 'design-system/UpgradeWebModal';
import { Tier } from 'features/premium/entities';
import { formatAmount } from 'utils/formatting';
import Modal from 'utils/packages/Modal';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { isWeb } from '../../../constants';
import { selectAutosaveFees, selectFreeAutosaveOnPlus } from '../reducers/selectors';
const AutosaveFeeInfoModalContent = ({ fee }) => {
    const navigation = useMainStackNavigation();
    const currentFee = useAppSelector(selectAutosaveFees);
    const freeAutosaveOnPlus = useAppSelector(selectFreeAutosaveOnPlus);
    const savingsPlanTierFees = useAppSelector((state) => state.pots.savingsPlanTierFees);
    const feeOnFree = savingsPlanTierFees?.[Tier.free];
    const feesStr = formatAmount(fee.value, fee.currency, 2);
    const onClose = useCallback(() => {
        Modal.hide();
    }, []);
    const upgrade = useCallback(() => {
        Modal.hide(() => {
            if (isWeb) {
                UpgradeWebModal.show(undefined);
                return;
            }
            navigation.navigateDeprecated('EmmaProModal', {});
        });
    }, []);
    return (<View style={styles.modalContainer}>
      <Spacer h={16}/>
      {fee.value ? (<Text TextThin-14 Secondary centered>
          A{' '}
          <Text NumbersThin-14 Secondary>
            {feesStr}
          </Text>{' '}
          fee is applied to each Autosave. This fee is waived for users subscribed to{' '}
          {freeAutosaveOnPlus ? 'Emma Plus, ' : null}Emma Pro and Emma Ultimate.
        </Text>) : (<Text TextThin-14 Secondary centered>
          As an Emma premium member, you enjoy free Autosave. We’ve waived the standard{' '}
          {feeOnFree ? `${formatAmount(feeOnFree, 'GBP')} ` : ''}fee for you.
        </Text>)}
      <Spacer h={32}/>
      {!!currentFee && (<>
          <Button brandReversed title="Upgrade for free autosaves" onPress={upgrade}/>
          <Spacer h={8}/>
        </>)}
      <Button brand title={'Okay'} onPress={onClose}/>
    </View>);
};
const AutosaveFeeInfoModal = {
    show: (fee) => {
        Modal.show(<AutosaveFeeInfoModalContent fee={fee}/>, {
            containerStyle: styles.modal,
            title: 'Autosave fee',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    modalContainer: {
        paddingHorizontal: rem(16),
    },
});
export default AutosaveFeeInfoModal;
